import api from "./ApiURLBase";
const EndPointGetVehicles = async (miningSiteId, vehicleId = '', plateNumber = '', vehicleTypeId = '') =>
  await api.get(`/vehicles/GetVehicles?miningSiteId=${miningSiteId}&vehicleId=${vehicleId}&plateNumber=${plateNumber}&vehicleTypeId=${vehicleTypeId}`);
const EndPointDeleteVehicle = async (id, miningSiteId) => await api.delete(`/vehicles/DeleteVehicle/${id}/${miningSiteId}`);
const EndPointCreateUpdateVehicle = async data => await api.post(`/vehicles/CreateUpdateVehicle/`, data);
const EndPointGetVehicleType = async () => await api.get(`/vehicleTypes/GetVehicleTypes`);
export {
  EndPointGetVehicles,
  EndPointDeleteVehicle,
  EndPointCreateUpdateVehicle,
  EndPointGetVehicleType
};
